
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObcPolarChart as ObcPolarChartElement} from '@oicl/openbridge-webcomponents/dist/bars-graphs/polar-chart/polar-chart.js';
 
 
 

 
 export const ObcPolarChart = createComponent({
   react: React,
   tagName: 'obc-polar-chart',
   elementClass: ObcPolarChartElement,
   events: {
     
   }
  });
 
 